<template>
  <section id="benefits" class="benefits">
    <h2>Benefits for Your Sales Team</h2>
    <div class="benefits-container">
      <div v-for="benefit in benefits" :key="benefit.id" class="benefit-item">
        <h4>{{ benefit.number }}</h4>
        <p>{{ benefit.text }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BenefitsSection',
  data() {
    return {
      benefits: [
        { id: 1, number: '70%', text: 'Reduction in Lead Finding Time' },
        { id: 2, number: '3x', text: 'Increase in Response Rates' },
        { id: 3, number: '45%', text: 'Shorter Sales Cycle' }
      ]
    }
  }
}
</script>

<style scoped>
.benefits {
  padding: 4rem 2rem;
  background: var(--light-bg);
}

h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.benefits-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 2rem;
}

.benefit-item {
  text-align: center;
}

.benefit-item h4 {
  font-size: 3rem;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
}
</style> 